<template>
  <div
    id="app"
    v-if="loaded"
    :class="{ viewer: isViewer }"
    :style="{ height: pageHeight, width: pageWidth }"
  >
    <div class="modal-sizing" ref="wrapObj" v-show="wrapShow"></div>
    <Index
      v-show="!gapDetect"
      v-if="mode === 'index'"
      ref="index"
      :drill="drill"
      :setting="setting"
    />
    <Question v-show="!gapDetect" v-if="mode === 'question'" />
    <QuestionList
      v-show="!gapDetect"
      v-if="mode === 'end'"
      :lastQuestions="lastQuestions"
      :question="nowQuestion"
      :orderList="orderList"
      :selectedList="selectedList"
      :setting="setting"
      :history="history"
      :gap="gap"
      :wrap="wrap"
    />
    <div class="mind-the-gap" :style="{ height: `${gap}px` }"></div>
  </div>
  <div v-else class="loadYaml">
    <div class="win" v-if="wait">
      <p v-if="wait === 'ERROR'">
        指定されたファイルは、正しいファイルではありません。教材の内容の入ったYAMLファイルを指定してください。
      </p>
      <p v-else>
        YAMLファイルが設定されていません。ボタンを押して教材の内容の入ったYAMLファイルを指定してください。
      </p>
      <input
        id="loadFile"
        type="file"
        @change="getYamlFromInput"
        style="display: none"
      />
      <label class="button" for="loadFile">YAML読み込み</label>
    </div>
    <div class="win" v-else>読み込み中</div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-console */
import axios from "axios";
import yaml from "yaml";

import Index from "@/components/pages/Index.vue";
import Question from "@/components/pages/Question.vue";
import QuestionList from "@/components/pages/QuestionList.vue";

import "@/assets/css/app.css";
import "@/assets/css/animate.min.css";

// import viewportUnitsBuggyfill from 'viewport-units-buggyfill';

export default {
  name: "app",
  components: {
    Index,
    Question,
    QuestionList
  },
  data() {
    return {
      isViewer: false,
      loaded: false,
      //      setting: {},
      //      questions: [],
      //      nowQuestionId: null,
      //      mode: 'index',
      history: [],
      lastData: {},
      lastQuestions: [],
      public: process.env.BASE_URL,

      orderList: [],
      selectedList: [],
      wait: true,

      wrap: 0,

      wrapShow: false,
      gapDetect: false,

      isiOS: false,
      isAndroid: false,
      isOldIos: false,
      pageHeight: null,
      pageWidth: "auto",
      iframe: false,
      gap: 0
    };
  },
  computed: {
    questions() {
      return this.$store.state.questions;
    },
    setting() {
      return this.$store.state.setting;
    },

    drill() {
      return this.$store.getters.drill;
    },
    mode() {
      return this.$store.state.mode;
    },

    horizontalGap() {
      const gap = 38;
      if (this.iframe && (this.isOldIos || this.isAndroid)) {
        return gap;
      }
      return 0;
    },
    verticalGap() {
      const gap = 87; // 48 + 39,
      if (this.iframe && (this.isOldIos || this.isAndroid)) {
        return gap;
      }
      return 0;
    }
  },
  created() {
    const ua = navigator.userAgent;
    this.isiOS =
      ua.match(/(iPad|iPhone|iPod)/i) ||
      (ua.toLowerCase().indexOf("macintosh") > -1 && "ontouchend" in document)
        ? true
        : false;
    this.isAndroid = ua.toLowerCase().indexOf("android") > -1;

    console.log("isiOS", this.isiOS);
    console.log("isAndroid", this.isAndroid);
  },
  mounted() {
    if (window !== parent.window) {
      this.iframe = true;
      if (window.name === "iframe_child") {
        this.isViewer = true;
      }
    }

    this.$nextTick(() => {
      this.displayInit();
    });
    if (file) {
      this.getQuestion(file);
      this.wait = false;
    }

    window.addEventListener("orientationchange", this.displayInit);
  },
  methods: {
    displayInit(e) {
      console.log("displayInit", this.isiOS, e);
      if (this.isiOS && this.iframe) {
        /*
        setTimeout(() => {
          // アドレスバーの高さぶん iframeを低くする
          const parentWindow = parent.window;
          const parentIframe = parent.window.document.querySelector(
            "iframe.content"
          );
          let parentDiv = parent.window.document.querySelector(
            "div.check100vh"
          );
          if (!parentDiv) {
            const div = document.createElement("div");
            div.style.height = "100vh";
            div.style.width = "100vw";
            div.style.position = "absolute";
            div.style.top = "0";
            parentWindow.document.body.appendChild(div);

            parentDiv = div;
          }

          const gap = parentDiv.clientHeight - parentWindow.innerHeight;
          console.log(gap);

          parentIframe.style.height = "";
          this.$nextTick(() => {
            const height = parentIframe.clientHeight - gap;
            parentIframe.style.height = height + "px";

            parentDiv.remove();
          });
        }, 50);
        */
      }

      /*
      setTimeout(() => {
        const isLandscape = window.innerHeight < window.innerWidth;
        if (this.isIos || this.isAndroid) {
          console.log("pageWidth changed");
          console.log("outerwidth ? :");
          console.log(window.outerWidth);
          if (window.outerWidth) {
            document.getElementsByTagName("html")[0].style.width =
              window.outerWidth + "px";
            this.pageWidth = window.outerWidth + "px";
          } else {
            console.log("innerwidth ? :");
            console.log(window.innerWidth);
            document.getElementsByTagName("html")[0].style.width =
              window.innerWidth + "px";
            this.pageWidth = window.innerWidth + "px";
          }

          if (this.isIos) {
            if (isLandscape) {
              document.getElementsByTagName("html")[0].style.height =
                parent.window.innerHeight - this.horizontalGap + "px";
              this.pageHeight =
                parent.window.innerHeight - this.horizontalGap + "px";
            } else {
              document.getElementsByTagName("html")[0].style.height =
                parent.window.innerHeight - this.verticalGap + "px";
              this.pageHeight =
                parent.window.innerHeight - this.verticalGap + "px";
            }
          }
        } else {
          console.log("pageWidth auto");
          document.getElementsByTagName("html")[0].style.width = "auto";
          this.pageWidth = "auto";
        }

        this.wrapShow = true;
        // parent.window.scrollTo(0, 0);
        // window.scrollTo(0, 0);
        if (this.isiOS && !this.gap) {
          this.gapDetect = true;
        }

        this.$nextTick(() => {
          if (this.isiOS && this.gapDetect) {
            this.gap = window.innerHeight - parent.window.innerHeight;

            console.log(this.gap);
            console.log(`gap: ${this.gap}`);
          }

          if (this.isiOS || this.isAndroid) {
            if (isLandscape) {
              this.wrap = parent.window.innerHeight - this.horizontalGap;
            } else {
              this.wrap = parent.window.innerHeight - this.verticalGap;
            }

            console.log(this.wrap);
          }

          if (this.isIos) {
            if (isLandscape) {
              this.pageHeight =
                parent.window.innerHeight - this.horizontalGap + "px";
            } else {
              this.pageHeight =
                parent.window.innerHeight - this.verticalGap + "px";
            }
          }

          if (this.gap < 0) {
            this.gap = 0;
          }
          this.wrapShow = false;
          this.gapDetect = false;
        });
      }, 100);
      */
    },
    getQuestion(fname) {
      axios(
        {
          methods: 'get',
          url: `${fname}`,
          validateStatus(status) {
            return (status >= 200 && status < 400) || status === 0
          }
        }).then(ev => {
        // console.log('axios okay', ev)
        const data = yaml.parse(ev.data);
        this.$store.commit("setQuestions", data);
        this.$nextTick(() => {
          this.loaded = true;
          this.$nextTick(() => {
            this.displayInit();
            try {
              if (drillId) {
                if (Number.isInteger(drillId) && drillId >= 0) {
                  this.$refs["index"].start(drillId);
                }
              }
            } catch (error) {
              let drillId = this.getParam("drillId");
              if (!Number.isNaN(parseInt(drillId))) {
                if (Number.isInteger(drillId * 1) && drillId >= 0) {
                  this.$refs["index"].start(drillId * 1);
                }
              }
            }
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    getParam(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    getYamlFromInput(e) {
      e.preventDefault();
      this.wait = false;
      const files = e.target.files;
      const file = files[0];
      const reader = new FileReader();
      reader.onload = e => {
        this.$nextTick(() => {
          try {
            const data = yaml.parse(e.target.result);
            // console.log(data);
            if (data.questionList && data.setting) {
              this.$store.commit("setQuestions", data);
              setTimeout(() => {
                this.loaded = true;
              }, 50);
            } else {
              this.wait = "ERROR";
            }
          } catch (e) {
            this.wait = "ERROR";
          }
        });
      };
      reader.readAsText(file);
    },
    /*
    start(idx) {
      // this.mode = 'question';
      // this.nowQuestionId = idx;
    },
    */
  },
  watch: {}
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;

  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

img {
  -webkit-touch-callout: none;
  user-select: none;
}

.mobile body {
  width: 100%;
  height: 100%;
}

#app {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

#app.viewer {
  overflow-y: auto;
  overflow-x: hidden;
}

/*
.mobile #app {
  padding-bottom: calc(48px + 38px);
}

.modal-sizing {
  width: 100vw;
  height: 100vh;
}

.mobile .modal-sizing {
  height: 100%;
}
*/

.modal-sizing {
  width: 100%;
  height: 100%;
}

.page {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.loadYaml {
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #ccc;

  justify-content: center;
  align-items: center;
}

.loadYaml .win {
  background: #fff;
  border: solid 2px #aaa;
  padding: 10px;

  border-radius: 10px;
  text-align: center;
}

.loadYaml .win label.button {
  background: #39b1e2;
  color: #fff;
  margin: 0;
  padding: 10px;

  border-radius: 5px;
}

.center .dropdown-item {
  text-align: center;
}

.mind-the-gap {
  background-color: #fff;
}
</style>
